<form [formGroup]="inputForm" class="holder">
  <mat-form-field>
    <mat-label>Vad tror du slutpriset blir?</mat-label>
    <input
      matInput
      formControlName="askingPrice"
      inputmode="numeric"
      spbFormatNumber>

    <span matTextSuffix>kr</span>
    @if (inputForm.controls.askingPrice.errors && inputForm.controls.askingPrice.touched) {
      <mat-icon matIconSuffix aria-hidden="true">priority_high
      </mat-icon>
    }

    <mat-error>
      @if (inputForm.controls.askingPrice.errors?.max) {
        Värdet får inte överstiga {{ 99999999 | number : '1.0-0' : 'fr' }} kr
      } @else {
        Fältet ska fyllas i.
      }
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Kontantinsats</mat-label>
    <input
      matInput
      formControlName="downPayment"
      inputmode="numeric"
      spbFormatNumber>
    <span matTextSuffix>kr</span>
    <mat-hint>
      Minst {{ hemnetService.downPaymentPercent() | percent:'1.0-0' }}
      ({{ hemnetService.minimumDownPayment() | number: '1.0-0': 'fr' }}) av bostadens pris.
      Observera att vi räknar enligt nya bolåneregler som börjar gälla 1 april.
    </mat-hint>
    @if (downPayment.errors && downPayment.touched) {
      <mat-icon aria-hidden="true" matIconSuffix>priority_high</mat-icon>
    }
    <mat-error>
      @if (downPayment.errors?.minDownPayment) {
        Värdet är för lågt. Kontantinsatsen måste vara minst
        {{ hemnetService.downPaymentPercent() | percent:'1.0-0' }}
        ({{ hemnetService.minimumDownPayment() | number: '1.0-0': 'fr' }}) av bostadens pris.
      }
      @if (downPayment.errors?.tooLarge) {
        Kontantinsatsen kan inte överstiga priset ({{ hemnetService.askingPrice() | number: '1.0-0' : 'fr' }} kr)
      }

    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Ränta</mat-label>
    <input
      matInput
      formControlName="interestRate"
      spbFormatNumber
      type="text">
    <span matTextSuffix>%</span>
    @if (inputForm.controls.interestRate.errors && inputForm.controls.interestRate.touched) {
      <mat-icon aria-hidden="true" matIconSuffix>priority_high</mat-icon>
    }

    @if (isListRate()) {
      <mat-hint>Genomsnittsränta senaste månaden för lån
        bundet på 3 månader
      </mat-hint>
    }
    <mat-error>Fältet ska fyllas i.</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Månadsavgift</mat-label>
    <input
      matInput
      formControlName="fee"
      inputmode="numeric"
      spbFormatNumber>
    <span matTextSuffix>kr</span>
    @if (inputForm.controls.fee.errors && inputForm.controls.fee.touched) {
      <mat-icon matIconSuffix aria-hidden="true">priority_high
      </mat-icon>
    }
    <mat-error>Värdet får inte överstiga {{ 99999 | number : '1.0-0' : 'fr' }} kr.</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Driftskostnad per år</mat-label>
    <input
      matInput
      formControlName="runCost"
      inputmode="numeric"
      spbFormatNumber>
    <span matTextSuffix>kr</span>
    @if (inputForm.controls.runCost.errors && inputForm.controls.runCost.touched) {
      <mat-icon aria-hidden="true" matIconSuffix>priority_high</mat-icon>
    }
    <mat-error>Värdet får inte överstiga {{ 999999 | number : '1.0-0' : 'fr' }} kr.
    </mat-error>
  </mat-form-field>
</form>